import React, { createContext, useContext } from "react";
import {
  Home,
  Store,
  Users,
  MonitorUp,
  User,
  BarChart3,
  FileSpreadsheet,
  PieChart,
  History,
  ChefHat,
  Flame,
  Bike,
  Truck,
  Route,
  Webhook,
  BookOpen,
  Layers3,
  LayoutGrid,
  Gift,
  Tag,
  MapPin,
  Ruler,
  Smartphone,
  Trash2,
  UtensilsCrossed,
  GlassWater,
  RotateCw,
  Activity,
  Database,
  Clock,
  Target,
  Timer,
  ClipboardCheck,
  Package,
} from "lucide-react";

interface BreadcrumbConfig {
  name: string;
  icon: React.ReactNode;
}

interface BreadcrumbContextData {
  getBreadcrumbConfig: (pathname: string) => BreadcrumbConfig | undefined;
}

const BreadcrumbContext = createContext<BreadcrumbContextData>(
  {} as BreadcrumbContextData
);

export const BreadcrumbProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const breadcrumbConfig: { [key: string]: BreadcrumbConfig } = {
    dashboard: { name: "Dashboard", icon: <Home size={16} /> },
    painel: { name: "Painel", icon: <LayoutGrid size={16} /> },
    "sequencia-pedidos": {
      name: "Sequência do dia",
      icon: <LayoutGrid size={16} />,
    },
    lojas: { name: "Lojas", icon: <Store size={16} /> },
    usuarios: { name: "Usuários", icon: <Users size={16} /> },
    entregadores: { name: "Entregadores", icon: <Bike size={16} /> },
    roterista: { name: "Roteirista", icon: <Route size={16} /> },
    "roterista-automatico": {
      name: "Roteirista Automático",
      icon: <Route size={16} />,
    },
    bordeiro: { name: "Bordeiro", icon: <Layers3 size={16} /> },
    "meu-perfil": { name: "Meu Perfil", icon: <User size={16} /> },
    metas: { name: "Metas", icon: <MonitorUp size={16} /> },
    coletiva: { name: "Coletiva", icon: <Users size={16} /> },
    individual: { name: "Individual", icon: <User size={16} /> },
    estatisticas: { name: "Estatísticas", icon: <BarChart3 size={16} /> },
    relatorios: { name: "Relatórios", icon: <FileSpreadsheet size={16} /> },
    "pizzas-por-sabor": {
      name: "Pizzas por sabor",
      icon: <PieChart size={16} />,
    },
    "pizzas-por-tamanho": {
      name: "Pizzas por tamanho",
      icon: <Ruler size={16} />,
    },
    "rodizio-pizzas": {
      name: "Rodízio de Pizzas",
      icon: <RotateCw size={16} />,
    },
    "salao-pizzas": {
      name: "Pizzas Salão",
      icon: <Store size={16} />,
    },
    "salao-bebidas": {
      name: "Bebidas Salão",
      icon: <GlassWater size={16} />,
    },
    "pizzas-brinde": {
      name: "Pizzas brinde",
      icon: <Gift size={16} />,
    },
    "pizzas-promocoes": {
      name: "Pizzas em promoções",
      icon: <Tag size={16} />,
    },
    "pedidos-por-bairro": {
      name: "Pedidos por bairro",
      icon: <MapPin size={16} />,
    },
    historicos: { name: "Históricos", icon: <History size={16} /> },
    "historico-pulo-borda": {
      name: "Pulo por falta de borda",
      icon: <History size={16} />,
    },
    "limpeza-pendentes": {
      name: "Pendentes excluídos",
      icon: <Trash2 size={16} />,
    },
    pizzaiolo: { name: "Pizzaiolo", icon: <ChefHat size={16} /> },
    forneiro: { name: "Forneiro", icon: <Flame size={16} /> },
    "producao-porcoes": {
      name: "Produção Porções",
      icon: <UtensilsCrossed size={16} />,
    },
    "producao-bebidas": {
      name: "Produção Bebidas",
      icon: <GlassWater size={16} />,
    },
    webhooks: { name: "Webhooks", icon: <Webhook size={16} /> },
    cardapio: { name: "Cardápio", icon: <BookOpen size={16} /> },
    bordas: { name: "Bordas", icon: <Layers3 size={16} /> },
    tamanhos: { name: "Tamanhos", icon: <Layers3 size={16} /> },
    "filas-integracao": {
      name: "Filas Integração",
      icon: <Layers3 size={16} />,
    },
    "fila-porcoes": {
      name: "Fila de Porções",
      icon: <Layers3 size={16} />,
    },
    "fila-bebidas": {
      name: "Fila de Bebidas",
      icon: <Layers3 size={16} />,
    },
    rodizio: {
      name: "Rodízio",
      icon: <UtensilsCrossed size={16} />,
    },
    urgencia: {
      name: "Urgência",
      icon: <UtensilsCrossed size={16} />,
    },
    "pizzaiolo-integracao": {
      name: "Pizzaiolo Integração",
      icon: <ChefHat size={16} />,
    },
    "aguardando-entrega": {
      name: "Aguardando Entrega",
      icon: <Truck size={16} />,
    },
    inspecao: { name: "Inspeção", icon: <BarChart3 size={16} /> },
    "atualizar-apk": {
      name: "Atualizar APK (app)",
      icon: <Smartphone size={16} />,
    },
    "mensagens-mobile": {
      name: "Mensagens mobile (app)",
      icon: <Smartphone size={16} />,
    },
    "ferramentas-desenvolvedor": {
      name: "Ferramentas de desenvolvedor",
      icon: <Smartphone size={16} />,
    },
    monitoramento: {
      name: "Monitoramento",
      icon: <Activity size={16} />,
    },
    backups: {
      name: "Backups",
      icon: <Database size={16} />,
    },
    crons: {
      name: "Crons",
      icon: <Clock size={16} />,
    },
    "controle-producao": {
      name: "Controle de Produção",
      icon: <ClipboardCheck size={16} />,
    },
    "und-medida": {
      name: "Unidades de Medida",
      icon: <Ruler size={16} />,
    },
    itens: {
      name: "Itens de Produção",
      icon: <ClipboardCheck size={16} />,
    },
    setores: {
      name: "Setores de Produção",
      icon: <Package size={16} />,
    },
    funcionamento: {
      name: "Funcionamento Produção",
      icon: <Clock size={16} />,
    },
    "base-semanal": {
      name: "Cadastro Base Semanal",
      icon: <Target size={16} />,
    },
    "ficha-diaria": {
      name: "Preencher Ficha Diária",
      icon: <FileSpreadsheet size={16} />,
    },
    "ficha-transferencia": {
      name: "Ficha de Transferência",
      icon: <Truck size={16} />,
    },
    sobras: {
      name: "Sobras",
      icon: <Package size={16} />,
    },
    "relatorio-consumo": {
      name: "Relatório Consumo",
      icon: <BarChart3 size={16} />,
    },
    "relatorio-tempos": {
      name: "Desempenho Produção",
      icon: <Timer size={16} />,
    },
    "relatorio-equipe": {
      name: "Equipe por Setor",
      icon: <Users size={16} />,
    },
  };

  const getBreadcrumbConfig = (pathname: string) => {
    return breadcrumbConfig[pathname];
  };

  return (
    <BreadcrumbContext.Provider value={{ getBreadcrumbConfig }}>
      {children}
    </BreadcrumbContext.Provider>
  );
};

export const useBreadcrumb = () => {
  const context = useContext(BreadcrumbContext);
  if (!context) {
    throw new Error(
      "useBreadcrumb deve ser usado dentro de BreadcrumbProvider"
    );
  }
  return context;
};
